var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_View_100424",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.076,
    height: 11.822,
    viewBox: "0 0 20.076 11.822",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35408",
    "data-name": "Group 35408",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63843",
    "data-name": "Path 63843",
    d: "M9.992,11.822c5.363,0,9.817-5.236,9.817-5.236a1.023,1.023,0,0,0,.011-1.365S15.586,0,10.038,0,.257,5.221.257,5.221A1.034,1.034,0,0,0,.263,6.592s4.367,5.23,9.73,5.23Zm.046-1.739A4.173,4.173,0,1,0,5.878,5.911a4.167,4.167,0,0,0,4.161,4.173Zm0-2.318A1.854,1.854,0,1,0,8.189,5.911a1.852,1.852,0,0,0,1.849,1.854Z",
    transform: "translate(0)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9aba526e5b4e052c7e708cb7a7219078.svg";
export { ForwardRef as ReactComponent };